import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

/**
 * Normalize legacy plain-text content into proper HTML paragraphs so the
 * editor opens with the same paragraph structure the user sees.
 * If the value already looks like HTML, return as-is.
 */
const normalizeIncoming = (value) => {
  if (!value) return '';
  if (/<\w+[\s>\/]/.test(value)) return value; // already HTML
  return value
    .split(/\n{2,}/)
    .map((para) => `<p>${para.trim().replace(/\n/g, '<br/>')}</p>`)
    .join('');
};

const RichTextEditor = ({ value, onChange, placeholder, testId = 'rte' }) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        ['clean'],
      ],
      clipboard: { matchVisual: false },
    }),
    [],
  );

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'indent',
    'align',
    'blockquote', 'code-block',
    'link', 'image',
  ];

  return (
    <div data-testid={testId} className="rte-wrap">
      <ReactQuill
        theme="snow"
        value={normalizeIncoming(value)}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
